import { useQuery, type QueryClient } from '@tanstack/react-query';
import type { ReadPositions } from '@avslack/shared';
import { listReadPositions } from '../lib/api';

/**
 * Ki hol tart a csatornaban.
 *
 * Ebbol szuletik a "latta" jelzes. A szerver csak a POZICIOT adja
 * (`lastReadSeq`), nem uzenet-azonositokat - igy egy esemeny akkor is eleg, ha
 * kozben tiz uzenet erkezett, es a szamolas itt, egy helyen tortenik.
 */
export const readsKey = (channelId: string) => ['reads', channelId] as const;

export function useReadPositions(channelId: string) {
  return useQuery({
    queryKey: readsKey(channelId),
    queryFn: async (): Promise<ReadPositions> => {
      const rows = await listReadPositions(channelId);
      return Object.fromEntries(rows.map((row) => [row.userId, row.lastReadSeq]));
    },
    staleTime: 60_000,
  });
}

/**
 * Egy visszajelzes beirasa.
 *
 * A pozicio csak NOHET: egy kesve erkezo, regebbi esemeny nem viheti vissza a
 * jelzest "meg nem latta"-ra. Ez ugyanaz a szabaly, mint a szerveren.
 */
export function applyReadReceipt(
  queryClient: QueryClient,
  channelId: string,
  userId: string,
  lastReadSeq: number,
): void {
  queryClient.setQueryData<ReadPositions>(readsKey(channelId), (current) => {
    const previous = current?.[userId] ?? 0;
    if (lastReadSeq <= previous) return current;
    return { ...current, [userId]: lastReadSeq };
  });
}
